<template>
  <div class="animated fadeIn">
    <Forms ref="frmSearch"
           title="PESQUISA DE AUTORIZAÇÕES"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Search="onClickSearch"
           :ShowFooterImbo="true"
           v-on:Clear="onClearSearch">
      <div class="form-group row">
          <label v-if="!detailsDire" for="cbxInsure">Situação:</label>
          <div  class="input-group">
            <b-form-select v-if="!detailsDire" v-model="searchForm.situacao.value" :options="searchForm.situacao.options">
              <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  <option v-for="data in dataSituacao" :key="data.value" :value="data.value" >{{data.text}}</option>
              </template>
            </b-form-select>
          </div>
          <label for="cbxInsure">Obra:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          type="text"
                          placeholder="Digite o nome da Obra"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.referencia + ' - ' + obra.localizacao"
                          :debounceLength="2"
                          :formField="searchForm.obraID"
                          v-on:search="onSearchObra"
                          v-on:changeCode="onChangeCodeObra"/>
          <label for="txtInsured"> Responsável:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          placeholder="Digite o nome do Responsável"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="searchForm.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
          <label for="txtInsured"> Funcionário:</label>
          <autocomplete-z ref="favorecidoTypeahead"
                          type="text"
                          placeholder="Digite o nome do Funcionário"
                          iconClass="fas fa-id-badge"
                          :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                          :debounceLength="2"
                          :formField="searchForm.favorecidoID"
                          v-on:search="onSearchFavorecido"
                          v-on:changeCode="onChangeCodeFavorecido" />
                          <label for="cbxInsure">Lote:</label>
                          <autocomplete-z ref="termoLoteTypehead"
                              placeholder="Digite o nome da Obra"
                              type="text"
                              iconClass="fas fa-file-excel"
                              :serializer="(despesaLog) => despesaLog.nomeArquivo"
                              :debounceLength="2"
                              :formField="searchForm.despesaLog"
                              v-on:search="GetTermoLog"
                              v-on:changeCode="onChangeCodeTermoLog"/>
                            </div>
            <label for="cbxInsure">Regional:</label>
            <div class="d-flex">
              <span class="input-group-addon"><i class="fas fa-industry"></i></span>
                <b-form-input type="text"
                class="col-3 text-upper"
                style="height: calc(2.09375rem + 2px);border-right: 0px;"
                :placeholder="'Código'"
                v-model="searchForm.secaoRH.value"
                :size="searchForm.secaoRH.maxlength"
                @focus="onClearSection"
                v-on:change="onChangeCodeSection"
                />
                <b-form-select v-model="searchForm.secaoRHID.value"
                >
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                </template>
                <option v-for="data in  dataRh" :key="data.id" :value="data.id">{{data.nome}}</option>
              </b-form-select>
            </div>
      <template v-slot:FooterButtonLeft>
        <button type="button" class="btn btn-third btn-sm d-none" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"><i class="fas fa-plus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.New}}</span></button>
      </template>
    </Forms>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../mixins/ExpenseMixin.js'
import { loading } from '@/shared/utils/UIHelper'
import SearchForm from '../search/search-form'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import termtype from '@/shared/utils/termtype.js'
import AuthorizationsModal from '../authorizations/authorizations-modal.vue'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ ActionsForm, ExpenseMixin ],
  name: 'Formserachauthorization',
  data () {
    return {
      searchForm: SearchForm,
      form: {
        accept: {
          value: null,
          required: false,
          state: null,
          typeTerm: termtype
        }
      },
      dataRh: [],
      dataSituacao: []

    }
  },
  components: {
    AuthorizationsModal,
    AutocompleteZ
  },
  computed: {
    filters: function () {
      return {
        obraID: this.searchForm.obraID.value,
        responsavelID: this.searchForm.responsavelID.value,
        RegionalId: this.searchForm.secaoRHID.value,
        situacao: this.searchForm.situacao.value,
        FuncionarioId: this.searchForm.favorecidoID.value,
        despesaLog: this.searchForm.despesaLog.value
      }
    }
  },
  props: {
    detailsDire: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted () {
    this.onLoadAllSections()
    this.getEnum()
  },
  methods: {
    onLoadAuthorization (filters) {
      loading.push()
      AcceptanceTermRepository.GetAllPaging(this.CompanySelected, this.typeTerm.REIMBURSEMENT_OF_EXPENSES, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, filters)
        .then((response) => {
          this.onResultGrid(response)
          // TODO: Show success
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeCodeSection (value) {
      var options = this.form.secaoRHID.options
      this.form.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.form.secaoRHID.value = options[i].value
        }
      }
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          this.dataRh = response.data.data
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onClearSearch () {
      this.searchForm.situacao.value = null
      this.searchForm.obraID.value = null
      this.searchForm.responsavelID.value = null
      this.searchForm.secaoRH.value = null
      this.searchForm.secaoRHID.value = null
      this.$refs.responsavelTypeahead.clear()
      this.$refs.favorecidoTypeahead.clear()
      this.$refs.obraRHTypeahead.clear()
      this.$refs.termoLoteTypehead.clear()
      localStoreHelper.prestacaoContas.adiantamento(null)
    },
    onClickSearch () {
      this.searchForm.situacao.value = this.searchForm.situacao.value == null ? null : parseInt(this.searchForm.situacao.value)
      this.$emit('searchAuth', this.filters)
      localStoreHelper.prestacaoContas.adiantamento(this.filters)
    },
    onClearSection () {
      this.searchForm.secaoRH.value = ''
    },
    getEnum () {
      loading.push()
      AcceptanceTermRepository.GetEnumSituacao()
        .then(Response => {
          loading.pop()
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    }
  }
}
</script>

<style>

.serachForm{
  width: 250px;
  height: 30px;
  background: #008144;
  border-radius: 25px;
  color: white;
  border: none;
}
.serachForm:hover{
  background: #004d29;
}
.serachFormClean{
  width: 250px;
  height: 30px;
  border: none;
  background: #C3C3C3;
  color: black;
  border-radius: 25px;
}
.serachFormClean:hover{
  background: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/formserachauthorization/formserachauthorization.vue